import React, { useCallback } from 'react';
import { ReactComponent as Cross } from '../webcommon/common/Icons/Cross-Disabled.svg';
import { ReactComponent as Details } from '../webcommon/common/Icons/Details.svg';
import OnRowClick from '../common/customgridcomponents/OnRowClick';


export const EditRow = row => (
    <OnRowClick onClick={ row.column.getGridProps().editRow } id={ row.original.id }>
        <Details />
    </OnRowClick>
);

export const DeleteRow = (row) => {
    const gridProps = row.column.getGridProps();
    const deleteRowWithId = useCallback(() => {
        gridProps.deleteRow(row.original.id);
    }, [gridProps, row.original.id]);
    return (
        <OnRowClick onClick={ deleteRowWithId } id={ row.original.id }>
            <Cross />
        </OnRowClick>
    );
};
